import applicationStore from "../../ApplicationStore";
import { ActionType } from "../../actions";

export class BookingTolerancesFiltersActions {
  public static updateFiltersData(data: any) {
    applicationStore.dispatch({
      type: ActionType.BOOKING_TOLERANCES_FILTERS_DATA_UPDATED,
      data,
    });
  }

  public static resetFiltersData() {
    applicationStore.dispatch({
      type: ActionType.BOOKING_TOLERANCES_FILTERS_DATA_RESET,
    });
  }
}
